const HeadingBlockIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path fill="#ffd400" d="M1 1h22v22H1z" />
    <path d="M22 2v20H2V2h20m2-2H0v24h24V0z" fill="#333" />
    <path fill="#333" d="M14 6v5h-4V6H8v12h2v-5h4v5h2V6h-2z" />
  </svg>
);

export default HeadingBlockIcon;
